import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#0F0F0F",
      "fill-rule": "evenodd",
      d: "M11.77 4.23c.261.261.261.683 0 .943l-6.598 6.6a.667.667 0 0 1-.943-.943l6.6-6.6c.26-.26.682-.26.942 0",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#0F0F0F",
      "fill-rule": "evenodd",
      d: "M4.231 4.23c.26-.26.683-.26.943 0l6.598 6.599a.667.667 0 0 1-.943.943L4.231 5.173a.667.667 0 0 1 0-.943",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }